// src/config/api.js
const getApiBaseUrl = () => {
  const { hostname, port } = window.location;

  console.log('Current hostname:', hostname, 'Port:', port); // Debug log

  // Localhost
  if (hostname === "localhost") {
    return "ws://192.168.1.109:8008";
  }

  // 192.168.1.202:7002
  if (hostname === "192.168.1.109" && port === "8000") {
    return "ws://192.168.1.109:8008";
  }

  if (hostname === "122.176.232.35" && port === "8080") {
    return "ws://122.176.232.35:8008";
  }

  return "wss://websocket.hospitalguru.in";
};

export const SOCKET_URL = getApiBaseUrl();